// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_wrapper__SENXM {
  margin-top: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;
}

.style_leaderboard__AcZwa {
  margin-top: 16px;
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(3, 108px);
  gap: 15px;
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  height: auto;
  justify-content: center;
}

.style_positions__z\\+3ZC {
  margin-top: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 2px solid rgb(117, 83, 240);
  border-radius: 20px;
  padding: 8px;
}

.style_clan__cHaoK {
  display: flex;
  border-radius: 12px;
  padding: 8px;
}
.style_clan__active__gNX4q {
  background: rgb(117, 83, 240);
}
.style_clan__left__5Gl9I {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 3 1;
}
.style_clan__position__R0avH {
  color: rgb(27, 27, 27);
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  width: 37px;
}
.style_clan__position__active__eyniZ {
  color: rgb(255, 255, 255);
}
.style_clan__members__ag0gM {
  display: flex;
  gap: 1px;
  align-items: center;
  color: rgb(27, 27, 27);
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
}
.style_clan__members__active__uHTMb {
  color: rgb(255, 255, 255);
}
.style_clan__content__SXGyb {
  display: flex;
  align-items: center;
  gap: 4px;
}
.style_clan__content__image__lwDws {
  width: 34px;
  height: 34px;
}
.style_clan__content__text__tHIPd {
  display: flex;
  flex-direction: column;
}
.style_clan__content__title__a196h {
  color: rgb(27, 27, 27);
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 150%;
  max-width: 190px;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.style_clan__content__title__active__OBjOZ {
  color: rgb(255, 255, 255);
}
.style_clan__right__YmOt8 {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: rgb(27, 27, 27);
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 16px;
  text-align: left;
}
.style_clan__right__active__gS1eq {
  color: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/features/clans-war/components/clan-war-leaderboard/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,mBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AADF;AAGE;EACE,6BC5CG;AD2CP;AAIE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AAFJ;AAKE;EACE,sBCrDU;EDsDV,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAHJ;AAKI;EACE,yBC1DE;ADuDR;AAOE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,sBCrEU;EDsEV,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AALJ;AAOI;EACE,yBCzEE;ADoER;AASE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAPJ;AASI;EACE,WAAA;EACA,YAAA;AAPN;AAUI;EACE,aAAA;EACA,sBAAA;AARN;AAWI;EACE,sBChGQ;EDiGR,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AATN;AAWM;EACE,yBCxGA;AD+FR;AAcE;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBCrHU;EDsHV,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAZJ;AAcI;EACE,yBCzHE;AD6GR","sourcesContent":["@import 'public/assets/colors';\n\n.wrapper {\n  margin-top: 16px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  max-width: 350px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.leaderboard {\n  margin-top: 16px;\n  width: 100%;\n  display: grid;\n  grid-auto-flow: column;\n  grid-template-columns: repeat(3, 108px);\n  gap: 15px;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  white-space: nowrap;\n  height: auto;\n  justify-content: center;\n}\n\n.positions {\n  margin-top: 16px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border: 2px solid $main;\n  border-radius: 20px;\n  padding: 8px;\n}\n\n.clan {\n  display: flex;\n  border-radius: 12px;\n  padding: 8px;\n\n  &__active {\n    background: $main;\n  }\n\n  &__left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 3;\n  }\n\n  &__position {\n    color: $black-extra;\n    font-size: 1.6rem;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: center;\n    width: 37px;\n\n    &__active {\n      color: $white;\n    }\n  }\n\n  &__members {\n    display: flex;\n    gap: 1px;\n    align-items: center;\n    color: $black-extra;\n    font-size: 1.2rem;\n    font-weight: 500;\n    line-height: 14px;\n    text-align: left;\n\n    &__active {\n      color: $white;\n    }\n  }\n\n  &__content {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    &__image {\n      width: 34px;\n      height: 34px;\n    }\n\n    &__text {\n      display: flex;\n      flex-direction: column;\n    }\n\n    &__title {\n      color: $black-extra;\n      font-size: 1.6rem;\n      font-weight: 600;\n      line-height: 150%;\n      max-width: 190px;\n      text-align: start;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      &__active {\n        color: $white;\n      }\n    }\n  }\n\n  &__right {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    color: $black-extra;\n    font-size: 1.6rem;\n    font-weight: 700;\n    line-height: 16px;\n    text-align: left;\n\n    &__active {\n      color: $white;\n    }\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `style_wrapper__SENXM`,
	"leaderboard": `style_leaderboard__AcZwa`,
	"positions": `style_positions__z+3ZC`,
	"clan": `style_clan__cHaoK`,
	"clan__active": `style_clan__active__gNX4q`,
	"clan__left": `style_clan__left__5Gl9I`,
	"clan__position": `style_clan__position__R0avH`,
	"clan__position__active": `style_clan__position__active__eyniZ`,
	"clan__members": `style_clan__members__ag0gM`,
	"clan__members__active": `style_clan__members__active__uHTMb`,
	"clan__content": `style_clan__content__SXGyb`,
	"clan__content__image": `style_clan__content__image__lwDws`,
	"clan__content__text": `style_clan__content__text__tHIPd`,
	"clan__content__title": `style_clan__content__title__a196h`,
	"clan__content__title__active": `style_clan__content__title__active__OBjOZ`,
	"clan__right": `style_clan__right__YmOt8`,
	"clan__right__active": `style_clan__right__active__gS1eq`
};
export default ___CSS_LOADER_EXPORT___;
